var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grab-tenants-view"},[_c('v-row',[(_vm.showTenants)?_c('v-col',{staticClass:"pa-0 ml-4 mt-4 mb-4 d-flex align-stretch",attrs:{"cols":"auto"}},[_c('TenantTree')],1):_vm._e(),_c('v-col',{staticClass:"home-background pa-0 ma-4",attrs:{"cols":"9,auto"}},[_c('router-view',{on:{"showTenants":_vm.onShowTenants}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }